import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import {
  UPDATE_ACTIVE_DIALOG,
  UPDATE_INACTIVE_DIALOG,
  UPDATE_ACTIVE_ADD_DIALOG,
  UPDATE_INACTIVE_ADD_DIALOG
} from './constants'

const updateActiveDialog = (prev, { active }) => active
const updateActiveAddDialog = (prev, { activeAdd }) => activeAdd

const activeDialogReducer = createReducer(false, {
  [UPDATE_ACTIVE_DIALOG]: updateActiveDialog,
  [UPDATE_INACTIVE_DIALOG]: updateActiveDialog,
})

const activeAddDialogReducer = createReducer(false, {
  [UPDATE_ACTIVE_ADD_DIALOG]: updateActiveAddDialog,
  [UPDATE_INACTIVE_ADD_DIALOG]: updateActiveAddDialog
})

export default combineReducers({
  active: activeDialogReducer,
  activeAdd: activeAddDialogReducer
})
